// Dependencies
import React from "react";
import PropTypes from "prop-types";

const Table = (props) => {
  return (
    <table className="c-table-data">
      <thead className="c-table-data__header">
        <tr className="c-table-data__row">
          <th
            colSpan="2"
            className="c-table-data__cell c-table-data__cell--border-radius c-table-data__cell--bg-dark c-table-data__cell--border-none"
          >
            <h5 className="c-table-data__title c-table-data__title--white">
              Información sobre protección de datos y uso de IA (inteligencia artificial)
            </h5>
          </th>
        </tr>
      </thead>
      <tbody className="c-table-data__body">
        <tr className="c-table-data__row">
          <td className="c-table-data__cell c-table-data__cell--width-thirty">
            <strong>Responsable del tratamiento</strong>
          </td>
          <td className="c-table-data__cell">
            <p className="c-table-data__text c-table-data__text--bottom-ten">Facthum Spain, S.L. (FACTHUM)</p>
            <p className="c-table-data__text c-table-data__text--bottom-ten">
              Domicilio Social: Calle José Echegaray nº 8. Edificio 3, 1ª planta. Parque empresarial Alvia. Las Rozas de Madrid, Madrid. 28232
            </p>
            <p className="c-table-data__text c-table-data__text--bottom-ten">CIF: B85643328</p>
          </td>
        </tr>
        <tr className="c-table-data__row">
          <td className="c-table-data__cell">
            <strong>Finalidades del tratamiento</strong>
          </td>
          <td className="c-table-data__cell">
            <p className="c-table-data__text">
             Sus datos se tratan en el contexto del proceso de evaluación del que usted forma parte y al que ha sido invitado por parte de su empresa. Los datos evaluados pueden ser rasgos de personalidad, competencias, aptitudes, nivel de inglés, etc. El objetivo de la evaluación es facilitar la toma de decisiones por parte de la empresa que le ha invitado.
            </p>
            <br/>
            <p className="c-table-data__text">
              En el caso de haber sido solicitado por la empresa el uso de aplicaciones de IA (inteligencia artificial) en su proceso evaluativo, le comunicamos que existe la prohibición de generar puntuaciones sociales o de comportamiento tratando medidas y datos indirectos tales como sexo, edad, estrato socioeconómico, lugar de residencia y otros datos afines, por lo que estos datos no formarán parte de su proceso de evaluación profesional.
            </p>
            <br/>
            <p className="c-table-data__text">
              De la misma forma, le informamos que los datos obtenidos con el uso de aplicaciones de IA (inteligencia artificial) en la plataforma online no saldrán fuera de la misma plataforma y no serán compartidos con terceros ajenos al proceso de evaluación encargado por la empresa. 
            </p>
            <br/>
            <p className="c-table-data__text">
              Los datos anteriormente referidos a aptitudes, competencias y personalidad, están clasificados con nivel de seguridad alto según legislación vigente. Si sus datos fueran a ser tratados con una aplicación integrada de IA, el alcance del mismo se limitará a la generación de un análisis de ajuste individual a un perfil profesional determinado, a la identificación de fortalezas y oportunidades de desarrollo particulares, la  identificación del estilo individual más frecuente en el trabajo combinando las variables evaluadas, o el posible agrupamiento de sus datos junto con los de otros participantes para esa misma evaluación encargada por la empresa sobre un perfil profesional determinado.
            </p>
            <br/>
            <p className="c-table-data__text">
              En el momento de la entrega de resultados, habrá un profesional de la evaluación de personas que supervisará la información emitida y que podrá modificar esta información para ajustarla a los límites legales establecidos.
            </p>
          </td>
        </tr>
        <tr className="c-table-data__row">
          <td className="c-table-data__cell">
            <strong>Legitimación del tratamiento</strong>
          </td>
          <td className="c-table-data__cell">
            <p className="c-table-data__text">
              Sus datos personales serán tratados por el consentimiento expresamente otorgado por usted.
            </p>
          </td>
        </tr>
        <tr className="c-table-data__row">
          <td className="c-table-data__cell">
            <strong>Conservación de los datos</strong>
          </td>
          <td className="c-table-data__cell">
            <p className="c-table-data__text">
              Los criterios que FACTHUM utiliza para fijar los plazos de conservación de sus datos han sido determinados de acuerdo con los requisitos establecidos en la legislación, reglamentos y directrices normativas aplicables, así como los requisitos operacionales de FACTHUM relacionados con las necesidades de la empresa que le ha invitado.
            </p>
          </td>
        </tr>
        <tr className="c-table-data__row">
          <td className="c-table-data__cell">
            <strong>Comunicación de los datos</strong>
          </td>
          <td className="c-table-data__cell">
            <p className="c-table-data__text">
              Sus datos personales pueden ser cedidos por FACTHUM a la empresa que ha solicitado su evaluación, cuando así se requiera para las finalidades del tratamiento indicadas anteriormente.
            </p>
          </td>
        </tr>
        <tr className="c-table-data__row">
          <td className="c-table-data__cell">
            <strong>Transferencia Internacional de datos</strong>
          </td>
          <td className="c-table-data__cell">
            <p className="c-table-data__text">No se realiza Transferencia Internacional de Datos.</p>
          </td>
        </tr>
        <tr className="c-table-data__row">
          <td className="c-table-data__cell">
            <strong>Derechos</strong>
          </td>
          <td className="c-table-data__cell">
            <p className="c-table-data__text c-table-data__text--bottom-ten">
              El consentimiento prestado en el supuesto previsto podrá ser revocado por usted en cualquier momento. Le informamos que de acuerdo con la legislación vigente usted tiene derecho a ejercer sus derechos de acceso, rectificación, oposición, derecho de supresión, de limitación del tratamiento y el derecho a la portabilidad de sus datos, derecho de información y derecho a no ser objeto de decisiones individuales automatizadas, acreditando su identidad (mediante copia de DNI o equivalente) en la siguiente dirección:  Facthum Spain, Calle José Echegaray nº 8. Edificio 3, 1ª planta, Parque empresarial Alvia, Las Rozas de Madrid, Madrid. 28232(España), o al siguiente email: info@facthum.com, acreditando su identidad (mediante copia de DNI o equivalente).
            </p>
            <p className="c-table-data__text">
              En caso de que no se haya satisfecho el ejercicio de sus derechos puede presentar una reclamación ante la Autoridad de Control. Obtenga más información en <a href="https://www.aepd.es/" style={{textDecoration: 'underline'}}>www.agpd.es</a>.
            </p>
          </td>
        </tr>
        <tr className="c-table-data__row">
          <td className="c-table-data__cell">
            <strong>Como hemos obtenido sus datos</strong>
          </td>
          <td className="c-table-data__cell">
            <p className="c-table-data__text">
              Los datos necesarios para el envío de esta evaluación (nombre y correo electrónico) han sido cedidos a FACTHUM por la empresa que solicita su evaluación.
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  );
}


// static propTypes = {
//   isVisible: PropTypes.bool.isRequired,
//   children: PropTypes.node.isRequired,
// };

export default Table;
